var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29684 0.292894L10.8897 4.88579C11.2763 5.27239 11.2763 5.89919 10.8897 6.28579C10.5031 6.67239 9.87634 6.67239 9.48974 6.28579L5.58974 2.38579L1.68974 6.28579C1.30314 6.67239 0.676337 6.67239 0.289738 6.28579C-0.0968616 5.89919 -0.0968616 5.27239 0.289738 4.88579L4.88263 0.292894C5.27316 -0.0976299 5.90632 -0.0976299 6.29684 0.292894V0.292894Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/Shape.7ef96d4048ccb8123b046c2f14f7db12.svg";
export { ForwardRef as ReactComponent };